module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-es-782bedf1bfc967e35d9f5b65785cac70.svg";